/*import { getHttpClient, errorDesconocido, safeHandle401 } from "../../../core/utils/httpClient";

export function error(error) {
    return { type: "CONFIG_BOX_ERROR", error };
}

export function loading(loading) {
    return { type: "CONFIG_BOX_LOADING", loading };
}

export function setSettings(data) {
    return { type: "CONFIG_BOX_SETTINGS", data };
}

export function setToken(data) {
    return { type: "CONFIG_BOX_TOKEN", data };
}

export function reset() {
    return { type: "CONFIG_BOX_RESET" };
}

export function loadSettings() {
    return async (dispatch, getState) => {
        dispatch(reset());
        dispatch(loading(true));

        var headers = {
            "Content-Type": "application/json",
        };

        try {
            const cliente = await getHttpClient(dispatch, getState());
            const response = await cliente.get("react/v1/box/settings", {}, { headers: headers });

            dispatch(setSettings(response.data));
            dispatch(loading(false));

            return true;
        } catch (e) {
            dispatch(loading(false));
            const test401 = safeHandle401(dispatch, getState);
            test401(e);

            if (e.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                if (e.response.status == 404) {
                    dispatch(error(e.response.data));
                    alert("Error 404 ");
                } else if (e.response.status != 400) {
                    alert("Error desconocido");
                }

                return e.response.data;
            }

            dispatch(error("Error desconocido"));
            errorDesconocido();
            return "Error";
        }
    };
}

export function updateToken() {
    return async (dispatch, getState) => {
        dispatch(reset());
        dispatch(loading(true));

        var headers = {
            "Content-Type": "application/json",
        };

        try {
            const cliente = await getHttpClient(dispatch, getState());
            const response = await cliente.get("react/v1/box/token", {}, { headers: headers });

            if (response.data) {
                dispatch(loading(false));
                dispatch(setToken(response.data));
                return true;
            } else {
                dispatch(loading(false));
                dispatch(error(true));
                return false;
            }
        } catch (e) {
            dispatch(loading(false));
            const test401 = safeHandle401(dispatch, getState);
            test401(e);
            if (e.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                if (e.response.status == 404) {
                    dispatch(error(e.response.data));
                    alert("Error 404 ");
                } else if (e.response.status != 400) {
                    alert("Error desconocido");
                }

                return e.response.data;
            }

            dispatch(error("Error desconocido"));
            errorDesconocido();
            return "Error";
        }
    };
}

export function postSettings(form) {
    return async (dispatch, getState) => {
        dispatch(error(""));
        dispatch(loading(true));

        const headers = { "Content-Type": "application/json" };

        try {
            const cliente = await getHttpClient(dispatch, getState());

            const response = await cliente.post("react/v1/box/test-credentials", form, { headers: headers });
            dispatch(loading(false));
            dispatch(setSettings(response.data));

            return response.data;
        } catch (e) {
            const test401 = safeHandle401(dispatch, getState);
            test401(e);
            dispatch(loading(false));
            dispatch(setSettings(null));

            if (e.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                if (e.response.status == 404) {
                    dispatch(error(e.response.statusText));
                } else if (e.response.status != 400) {
                    dispatch(error(e.response.statusText));
                }

                return e.response.data;
            }

            dispatch(error("Unknown error"));
            errorDesconocido();
            return "Error";
        }
    };
}

export const isAvailable = (state) => (state.config.box.settings ? true : false);
*/
import basicRequest from "../../../../core/redux/actions/request";

import { notification } from "antd";

const PREFIX_FORM = "BOX_SETTINGS";
export const getBoxSettings = (state) => state.config.box.settings;
const {
    getPattern,
    postPattern,
    isLoading: isBoxSettingsLoading,
    getData: getBoxSettingsData,
    reset: resetBoxSettings,
} = basicRequest(PREFIX_FORM, getBoxSettings);

export const loadSettings = () => {
    const url = "react/v1/box/settings";
    return getPattern(url, {});
};

export const postSettings = (form) => postPattern("react/v1/box/test-credentials", form);

export { isBoxSettingsLoading, getBoxSettingsData, resetBoxSettings };
